<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div appLifecycleTracker class="history-container" trackerName="threat-history">
    <div *ngIf="threatHistoryDataLoaded">
        <span class="threat-history-data-loaded"></span>
    </div>

    <div id="search" class="threat-search-container">
        <div class="threat-search">
            <mat-form-field appearance="outline">
                <input
                        placeholder="{{fSearchPlaceholder}}"
                        matInput
                        type="text"
                        appDebounceInput
                        debounceTime="500"
                        (debounceInput)="refreshThreats()"
                        (keyup)="onSearchKeyUp($event.target.value)"
                        maxlength="255"
                />
            </mat-form-field>
        </div>
        <div class="threat-time">
            <mat-form-field appearance="outline">
                <mat-label>{{fTimeFilter}}</mat-label>
                <mat-select [(ngModel)]="selectedTime" name="time"
                            (selectionChange)="onTimeChange($event)">
                    <mat-option *ngFor="let time of times" [value]="time.value">
                        {{time.displayValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="button-container" *ngIf="showExportThreatsButton">
            <button mat-raised-button color="primary" style="margin-right: 1em" (click)="exportCSV()">{{fExportCSV}}</button>
            <button mat-raised-button color="primary" (click)="exportJSON()">{{fExportJSON}}</button>
        </div>
    </div>
    <div class="history-content" id="history-content">
        <div class="filter-selector-container" id="control">
            <div id="sensortypes">
                <mat-form-field appearance="outline">
                    <mat-label>{{fThreatsFilter}}</mat-label>
                    <mat-select [formControl]="sensorsForm" id="Threat Types" multiple (selectionChange)="onSensorsChange($event)">
                        <mat-select-trigger>
                            {{sensorsForm.value != undefined && sensorsForm.value.length > 0 ?
                            sensorsForm.value[0].description || sensorsForm.value[0].displayValue :
                            ''}}
                            <span *ngIf="sensorsForm.value?.length > 1" class="additional-selection">
                                    (+{{sensorsForm.value.length - 1}}
                                {{sensorsForm.value?.length === 2 ? 'other' : 'others'}})
                                </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let sensor of sensorTypesFiltered" [value]="sensor">
                            {{sensor.description || sensor.displayValue}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div id="activeLockType">
                <mat-form-field appearance="outline">
                    <mat-label>{{fActiveLockFilter}}</mat-label>
                    <mat-select [formControl]="enabledForm" multiple (selectionChange)="onEnabledChange($event)">
                        <mat-select-trigger>
                            {{enabledForm.value != undefined && enabledForm.value.length > 0 ?
                            enabledForm.value[0].displayValue :
                            ''}}
                            <span *ngIf="enabledForm.value?.length > 1" class="additional-selection">
                                    (+{{enabledForm.value.length - 1}}
                                {{enabledForm.value?.length === 2 ? 'other' : 'others'}})
                                </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let activeLock of activeLockTypes" [value]="activeLock"
                                    id="activeLockType-{{activeLock.displayValue}}">
                            {{activeLock.displayValue}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div id="sourceType">
                <mat-form-field appearance="outline">
                    <mat-label>{{fSourceFilter}}</mat-label>
                    <mat-select [formControl]="sourcesForm" multiple (selectionChange)="onSourceChange($event)">
                        <mat-select-trigger>
                            {{sourcesForm.value != undefined && sourcesForm.value.length > 0 ?
                            sourcesForm.value[0].displayValue :
                            ''}}
                            <span *ngIf="sourcesForm.value?.length > 1" class="additional-selection">
                                    (+{{sourcesForm.value.length - 1}}
                                {{sourcesForm.value?.length === 2 ? 'other' : 'others'}})
                                </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let sourceType of sourceTypes" [value]="sourceType">
                            {{sourceType.displayValue}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="deviceSetsEnabled" id="devicesets">
                <mat-form-field appearance="outline">
                    <mat-label>{{fGroupsFilter}}</mat-label>
                    <mat-select [formControl]="deviceSetsForm" multiple
                                (selectionChange)="onDeviceSetChange($event)">
                        <mat-select-trigger>
                            {{deviceSetsForm.value != undefined && deviceSetsForm.value.length > 0 ?
                            deviceSetsForm.value[0].name :
                            ''}}
                            <span *ngIf="deviceSetsForm.value?.length > 1" class="additional-selection">
                                    (+{{deviceSetsForm.value.length - 1}}
                                {{deviceSetsForm.value?.length === 2 ? 'other' : 'others'}})
                                </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let deviceSet of deviceSets" [value]="deviceSet">{{deviceSet.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="totalResults > 0; else noData" class="table-container" id="tablepanel">
            <div class="cigent-box-container">
                <div *ngIf="totalResults != null" id="totalResults">
                    <b>{{totalResults | number}} {{fThreatsNumber}} </b>
                </div>
                <app-column-chooser class="column-chooser" saveId="threat-history" [elements]="choosableColumns" (change)="updateDisplayedColumns($event)"></app-column-chooser>
            </div>
            <div class="table-wrapper" id="table" (scroll)="onScrollHandler($event)">
                <table class="table" mat-table [dataSource]="threatData" matSort matSortDisableClear='true'
                       matSortActive="timestamp" matSortStart="desc" matSortDirection="desc"
                       (matSortChange)="sortColumn($event)" aria-describedby="Threats">
                    <ng-container matColumnDef="timestamp">
                        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{fTimestamp}}</th>
                        <td mat-cell *matCellDef="let threat" id="timestamp"> {{threat.timestamp | date : 'medium' }} </td>
                    </ng-container>
                    <ng-container matColumnDef="deviceName">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fEndpoints}}</th>
                        <td mat-cell *matCellDef="let threat" id="device-name"> {{threat.deviceName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="sensor">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fThreats}}</th>
                        <td mat-cell *matCellDef="let threat" id="threat-types"> {{threat.sensorDisplay}} </td>
                    </ng-container>
                    <ng-container matColumnDef="responseType">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fResponse}}</th>
                        <td mat-cell *matCellDef="let threat" id="response-type"> {{threat.responseTypeDisplay}} </td>
                    </ng-container>
                    <ng-container matColumnDef="enabled">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fActiveLock}}</th>
                        <td mat-cell *matCellDef="let threat" id="active-lock"> {{threat.activeLockAction}} </td>
                    </ng-container>
                    <ng-container matColumnDef="source">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fSource}}</th>
                        <td mat-cell *matCellDef="let threat" id="source"> {{threat.sourceDisplay}} </td>
                    </ng-container>
                    <ng-container matColumnDef="description">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fDescription}}</th>
                        <td mat-cell *matCellDef="let threat" id="description">
                            <div *ngIf="threat.description">{{threat.description}}</div>
                            <div class="smaller-font" *ngIf="threat.path">{{fDescDeception}} {{threat.path}}</div>
                            <div class="smaller-font" *ngIf="threat.process">{{fDescAccessed}} {{threat.process}}</div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="details">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fDetails}}</th>
                        <td mat-cell *matCellDef="let threat" id="details"> {{threat.detail}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                    <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
                </table>
            </div>
        </div>
        <ng-template #noData>
            <div *ngIf="totalResults == 0" class="no-data">
                <span id="noThreatsText" class="no-data">{{fNone}}</span>
            </div>
        </ng-template>
    </div>
</div>
